import { forwardRef } from "react";

const FlowerButton = forwardRef(({ children, variant = "burgundy", className = "", ...props }, ref) => {
  const variantClass = variant === "pink" ? "flower-pink" : variant === "sage" ? "flower-sage" : "";
  return (
    <button
      ref={ref}
      className={`flower-btn ${variantClass} ${className}`}
      {...props}
    >
      <span className="relative z-10 drop-shadow-sm">{children}</span>
    </button>
  );
});

FlowerButton.displayName = "FlowerButton";
export default FlowerButton;
